import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input, Alert } from "antd";
import { usrRole } from "../../utils/dataUtil";
//import { API_BASE } from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_list_ssp_target_goal_night,
 // req_downloadfile_ssp_target_goal_night,
} from "../../api";

class SchoolPlanTargetGoalNight extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
    totalTarget: 1,
    totalPlan: 0,
    totalConfident: 0,
  };

  componentWillMount() {
    this.api_item_list();
  }

  //////////
  api_item_list = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_target_goal_night(
      userCode,
      "VIEWER",
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      console.log(items);
      const totalTarget = items.reduce((accumulator, object) => {
        return accumulator + object.PlanALLApprovedTotal;
      }, 0);
      const totalPlan = items.reduce((accumulator, object) => {
        return accumulator + object.PlanQuotaTotal;
      }, 0);
      const totalConfident = items.reduce((accumulator, object) => {
        return accumulator + object.ConfidentQuotaTotal;
      }, 0);
      this.setState({ data: items, totalTarget, totalPlan, totalConfident });
      // console.log(totalTarget);
    } else {
      const items = [];
      this.setState({
        data: items,
        totalTagert: 0,
        totalPlan: 0,
        totalConfident: 0,
      });
    }
  };
  //////////
  render() {
    const {
      planAcademicYear,
      data,
      loading,
      totalTarget,
      totalPlan,
      totalConfident,
    } = this.state;
    const columns = [
      {
        title: "計畫學年",
        align: "center",
        responsive: ["lg"],
        dataIndex: "PlanAcademicYear",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "244": //民生暨管理學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeShortName",
        responsive: ["lg"],
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "244": //民生暨管理學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        align: "center",
        dataIndex: "EducationalSystemTwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "244": //民生暨管理學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "DeptmentShortName",
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "244": //民生暨管理學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: { fontWeight: 900, color: textColor },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <>
            一般獨招<br></br>(B5)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "BETargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: (
          <>
            四技申請<br></br>高中生(C)
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "CATargetTotal",
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 700, color: "#A9A9AF" },
            },
            children: <div>{text === 0 ? "" : text}</div>,
          };
        },
      },
      {
        title: "計畫學年核定招生名額",
        width: 180,
        children: [
          {
            title: "合計",
            dataIndex: "PlanALLApprovedTotal",
            align: "center",
            width: 180,
            render(text, record) {
              var textColor = "#FFF";
              switch (record.CollegeCode) {
                case "244": //民生暨管理學院
                  textColor = "#789017";
                  break;
                case "59": // 管理學院
                  textColor = "#0061ae";
                  break;
                case "62": // 設計學院
                  textColor = "#f08519";
                  break;
                case "63": // 藝術學院
                  textColor = "#e40082";
                  break;
                case "193": // 旅遊學院
                  textColor = "#00706a";
                  break;
                default:
                  break;
              }
              return {
                props: {
                  style: { fontWeight: 900, color: textColor },
                },
                children: <div>{text === 0 ? "" : text}人</div>,
              };
            },
          },
        ],
      },
      {
        title: (
          <>
            規劃年度<br></br>來源校數
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "SourceSchoolTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "244": //民生暨管理學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}所</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>規劃人數
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "PlanQuotaTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "244": //民生暨管理學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}人</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>規劃率
          </>
        ),
        align: "center",
        dataIndex: "PlanQuotaRatio",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  text < 110 ? "#FAC4BB" : text > 115 ? "#83eef7" : "#D1FABB",
              },
            },
            children: <div>{text}%</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>預收達成人數
          </>
        ),
        align: "center",
        responsive: ["lg"],
        dataIndex: "ConfidentQuotaTotal",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "244": //民生暨管理學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                fontWeight: 900,
                color: textColor,
              },
            },
            children: <div>{text}人</div>,
          };
        },
      },
      {
        title: (
          <>
            計畫學年<br></br>預達率
          </>
        ),
        align: "center",
        dataIndex: "ConfidentQuotaRatio",
        render(text, record) {
          return {
            props: {
              style: {
                fontWeight: 900,
                background: text >= 80 ? "#D1FABB" : "#FAC4BB",
              },
            },
            children: <div>{text}%</div>,
          };
        },
      },
    ];

    return (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "4px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        {/* <button
              className="btn btn-info"
              onClick={() => this.handle_show_ui_modal("download_all", {})}
              style={{ marginLeft: "2px", marginBottom: "4px" }}
            >
              <i className="fas fa-cloud-download-alt"></i>
            </button>
            <button
              className="btn btn-info"
              onClick={() => this.handle_show_ui_modal("download_small", {})}
              style={{ marginLeft: "2px", marginBottom: "4px" }}
            >
              <i className="fas fa-download"></i>
            </button> */}
        <Alert
          message={
            totalTarget > 0 ? (
              <>
                <span style={{ color: "orange", fontWeight: 900 }}>
                  教育部核定人數：{totalTarget}人
                </span>{" "}
                |{" "}
                <span style={{ color: "blue", fontWeight: 900 }}>
                  當前規劃人數： {totalPlan}人
                </span>{" "}
                |{" "}
                <span style={{ color: "green", fontWeight: 900 }}>
                  預收達成人數： {totalConfident}人
                </span>{" "}
              </>
            ) : (
              <></>
            )
          }
          type="error"
        />
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SchoolPlanTargetGoalNight);
